import { ArrowLeft, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useFirmContextStore } from "@/features/firm-context/store/firm-context-store";

/**
 * "Acting on behalf of {firm}" banner shown when a house user or GA/SA has
 * switched into a Business Practitioner's workspace. Exit clears the active
 * firm, returning to the in-house (CAP) book.
 */
export function FirmContextBanner({ firmName }: { firmName?: string }) {
  const navigate = useNavigate();
  const clearFirm = useFirmContextStore((s) => s.clearFirm);

  return (
    <Alert className="border-warning/40 bg-warning-soft pr-28">
      <Building2 className="text-warning" />
      <AlertTitle>Acting on behalf of {firmName ?? "this firm"}</AlertTitle>
      <AlertDescription>
        You&apos;re managing this firm&apos;s clients on its behalf — new clients and changes apply
        to its book.
      </AlertDescription>
      <Button
        variant="outline"
        size="sm"
        className="absolute top-3 right-4"
        onClick={() => {
          clearFirm();
          navigate("/clients");
        }}
      >
        <ArrowLeft /> Exit
      </Button>
    </Alert>
  );
}
